<template>
  <modal :show="show" @close="$emit('close')">
    <div class="modal-header">
      <button type="button" class="close" @click="$emit('close')">
        <span aria-hidden="true">×</span><span class="sr-only">Schließen</span>
      </button>
      <h1 class="modal-title">{{ title }}</h1>
    </div>
    <div class="modal-body">
      <slot>
        <p>{{ content }}</p>
      </slot>
    </div>
    <div class="modal-footer">
      <div class="pull-left">
        <button type="button" class="btn-primary" @click="$emit('close')">
          {{ cancel }}
        </button>
      </div>
      <div class="pull-right">
        <button type="button" class="btn-secondary" @click="$emit('confirm')">
          <span class="fa fa-exclamation-triangle"></span>
          {{ confirm }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'ModalTokenConfirm',
  props: ['show', 'title', 'content', 'cancel', 'confirm'],
  components: {
    Modal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalTokenConfirm.vue